import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = {
    userId: Number,
    currentUserId: Number,
    conversationId: Number
  }
  static targets = [ "status", "preview" ]

  connect() {
    this.statusElement = this.hasStatusTarget ? this.statusTarget : this.element
    this.previewElement = this.hasPreviewTarget ? this.previewTarget : null
    this.lastStatusHtml = this.statusElement.innerHTML
    this.lastPreviewHtml = this.previewElement ? this.previewElement.innerHTML : ""
    this.isTyping = false
    this.typingTimer = null

    this.subscribe()
    this.bindResetEvent()
  }

  disconnect() {
    this.unsubscribe()
    this.clearTypingTimer()
    this.unbindResetEvent()
  }

  subscribe() {
    this.subscription = consumer.subscriptions.create(
      { channel: "PresenceChannel" },
      {
        received: (data) => this.received(data)
      }
    )
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  received(data) {
    if (data.user_id === this.currentUserIdValue) return

    if (data.type === "typing") {
      this.handleTyping(data)
    } else if (data.type === "stop_typing") {
      this.handleStopTyping(data)
    } else {
      if (data.user_id !== this.userIdValue) return
      this.lastStatusHtml = data.html || ""
      if (!this.isTyping) this.statusElement.innerHTML = this.lastStatusHtml
    }
  }

  handleTyping(data) {
    if (!this.conversationIdValue || data.conversation_id !== this.conversationIdValue) return

    this.isTyping = true
    this.clearTypingTimer()

    const html = this.typingHtml()
    if (this.previewElement) {
      this.previewElement.innerHTML = html
    } else {
      this.statusElement.innerHTML = html
    }

    this.typingTimer = setTimeout(() => this.clearTyping(), 5000)
  }

  handleStopTyping(data) {
    if (!this.conversationIdValue || data.conversation_id !== this.conversationIdValue) return
    this.clearTyping()
  }

  clearTyping() {
    this.isTyping = false
    this.clearTypingTimer()
    this.statusElement.innerHTML = this.lastStatusHtml
    if (this.previewElement) {
      this.previewElement.innerHTML = this.lastPreviewHtml
    }
  }

  clearTypingTimer() {
    if (this.typingTimer) {
      clearTimeout(this.typingTimer)
      this.typingTimer = null
    }
  }

  typingHtml() {
    return '<span class="text-green-600">печатает…</span>'
  }

  bindResetEvent() {
    this.resetHandler = (event) => {
      if (event.detail && event.detail.conversation_id === this.conversationIdValue) {
        this.clearTyping()
      }
    }
    document.addEventListener("conversation:typing:reset", this.resetHandler)
  }

  unbindResetEvent() {
    if (this.resetHandler) {
      document.removeEventListener("conversation:typing:reset", this.resetHandler)
      this.resetHandler = null
    }
  }
}
